<template>
  <div id="page">
    <h1>Skills</h1>
    <div id="form">
      <form v-on:submit.prevent="addSkills()">
        <div class="row">
          <div class="form-group w-25">
            <input
              type="text"
              class="form-control"
              id="skill"
              placeholder="Nome da Skill que quer adicionar"
              v-model="skill"
            />
          </div>
          <button type="submit" id="add" class="btn btn-primary float-left">
            Adicionar
          </button>
        </div>
      </form>
    </div>
    <table class="table" id="table-skills">
      <thead>
        <tr>
          <th>Competência</th>
          <th>Remover</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="comp in skills" :key="comp.id_skills">
          <td>{{ comp.name }}</td>
          <td><button @click="deleteSkill(comp.id_skills)">🗑️</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: function() {
    return {
      skill: "",
      skills: [],
      delSkill: [],
    };
  },
  created() {
    this.getSkill();
  },
  methods: {
    async addSkills() {
      try {
        this.$store.dispatch("addSkills", {
          name: this.skill,
        });
        this.getSkill();
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async getSkill() {
      try {
        await this.$store.dispatch("fetchSkills");
        this.skills = this.getSkills.data;
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async deleteSkill(id) {
      this.delSkill = this.skills.filter((skill) => skill.id_skills == id);
      this.$swal({
        title: `Tem a certeza que pretende eliminar a competência ${this.delSkill[0].name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Eliminar!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("delSkills", {
              id: id,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Competência eliminado",
            });
            this.getSkill();
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getSkills"]),
  },
};
</script>
<style scoped>
#page {
  padding: 50px 60px 0px 300px;
}
#add {
  height: 50%;
  margin-left: 5px;
}
</style>
